<template>
  <button @click="show = true" class="btn btn-info btn-sm">
    <i class="fa fa-upload"></i>{{ $t('import') }}
    <b-modal v-model="show" :title="$t('import')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus size="xl">
      <div class="form-group">
        <label><b>{{ $t('downloadTemplate') }}</b></label>
        <div>
          <button @click="downloadTemplate" class="btn btn-sm btn-secondary mr-1 mb-2">
            <i class="fa fa-fw fa-lg fa-file-excel-o"></i>number-template.xlsx
          </button>
        </div>
      </div>
      <div class="form-group">
        <label><b>{{ $t('selectFile') }}</b></label>
        <b-form-file class="mb-3"
                     v-model="file"
                     :placeholder="$t('fileInputPlaceholder')"
                     :drop-placeholder="$t('fileInputPlaceholder')"
                     :browse-text="$t('selectFile')"
                     :disabled="reading||totalRows>0"
                     accept="application/x-iwork-keynote-sffnumbers,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ></b-form-file>
      </div>
      <div v-if="reading" class="alert alert-warning">
        <b-spinner small variant="primary"></b-spinner>&nbsp;
        <span>{{ $t('importReadingNotice') }}</span>
      </div>
      <div v-if="importing" class="alert alert-warning">
        <b-spinner small variant="primary"></b-spinner>&nbsp;
        <span>{{ $t('importingNotice') }}</span>
      </div>
      <div class="mb-3" v-if="totalRows">
        <b-progress :max="totalRows">
          <b-progress-bar :value="successCount+errorCount"
                          :label="`${(((successCount + errorCount) / totalRows) * 100).toFixed(0)}%`"></b-progress-bar>
        </b-progress>
        <div class="text-center">{{ successCount + errorCount }}/{{ totalRows }} | {{ $t('error') }}: {{ errorCount }}
          <a @click="downloadErrors" class="btn-link text-primary" href="javascript:">[{{ $t('detail') }}]</a>
        </div>
      </div>

      <div class="alert alert-warning">
        Lưu ý: Các cấu hình dưới đây sẽ áp dụng cho tất cả các số điện thoại trong danh sách tải lên ở file đã chọn
      </div>

      <div class="row">
        <div class="col-md">
          <form-checkbox :chk-label="$t('differenceInOutNumbers')" :model="formModel"
                         attribute="differenceInOutNumbers" :errors="formErrors"></form-checkbox>
          <form-input v-if="formModel.differenceInOutNumbers" :label="$t('outPhoneNumber')" :model="formModel"
                      attribute="outNumber" :errors="formErrors">
          </form-input>
          <country-select :model="formModel" :errors="formErrors"></country-select>
          <network-select :model="formModel" countryAttribute="country" :disabled="!formModel.country"
                          :errors="formErrors"></network-select>
          <host-select :model="formModel" countryAttribute="country" type="number" :disabled="!formModel.country"
                       :errors="formErrors"></host-select>
          <gateway-select :model="formModel" :disabled="!formModel.country" :errors="formErrors"></gateway-select>
          <form-checkbox :model="formModel" attribute="isFixedRoutingIp" :errors="formErrors"
                         :chk-label="$t('isFixedRoutingIp')"></form-checkbox>
          <form-input v-if="formModel.isFixedRoutingIp" :label="$t('fixedRoutingIp')" :model="formModel"
                      attribute="fixedRoutingIp" :errors="formErrors"></form-input>
          <form-input :label="$t('priority')" :model="formModel"
                      attribute="priority" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental" :label="$t('fixedCallFee')" :model="formModel" attribute="fixedCallFee"
                      :errors="formErrors"></form-input>
          <form-checkbox :chk-label="$t('inbound')" :model="formModel" attribute="inbound" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('outbound')" :model="formModel" attribute="outbound" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isDemo')" :model="formModel" attribute="isDemo" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isRental')" :model="formModel" attribute="isRental" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isSpam')" :model="formModel" attribute="isSpam" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isHidden')" :model="formModel" attribute="isHidden" :errors="formErrors">
          </form-checkbox>
        </div>
        <div class="col-3" v-if="formModel.isRental">
          <form-checkbox v-if="formModel.isRental" :chk-label="$t('privateFee')" :model="formModel"
                         attribute="privateFee" :errors="formErrors"></form-checkbox>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('setupFee')" :model="formModel"
                      attribute="setupFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('monthlyFee')" :model="formModel"
                      attribute="monthlyFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('netCallFee')" :model="formModel"
                      attribute="netCallFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('offnetCallFee')"
                      :model="formModel" attribute="offnetCallFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('minBillSecs')" :model="formModel"
                      attribute="minBillSecs" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('blockBillSecs')"
                      :model="formModel" attribute="blockBillSecs" :errors="formErrors"></form-input>

          <form-checkbox :chk-label="$t('isInboundCharge')" :model="formModel" attribute="isInboundCharge"
                         :errors="formErrors"/>
          <form-input v-if="formModel.isInboundCharge" :label="$t('inboundCallFee')" :model="formModel"
                      attribute="inboundCallFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isInboundCharge" :label="$t('inboundMinBillSecs')" :model="formModel"
                      attribute="inboundMinBillSecs" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isInboundCharge" :label="$t('inboundBlockBillSecs')" :model="formModel"
                      attribute="inboundBlockBillSecs" :errors="formErrors"></form-input>
        </div>
        <div class="col-3">
          <form-checkbox :chk-label="$t('isCommit')" :model="formModel" attribute="isCommit" :errors="formErrors"/>
          <form-input v-if="formModel.isCommit" :label="$t('commitMonthlyFee')" :model="formModel"
                      attribute="commitMonthlyFee" :errors="formErrors"></form-input>
          <form-date-time format="DD/MM/YYYY" v-if="formModel.isCommit" :label="$t('commitFromTime')" :model="formModel"
                          attribute="commitFromTime" :errors="formErrors"></form-date-time>
          <form-date-time format="DD/MM/YYYY" v-if="formModel.isCommit" :label="$t('commitToTime')" :model="formModel"
                          attribute="commitToTime" :errors="formErrors"></form-date-time>
          <div v-if="formModel.isCommit" class="alert alert-warning">
            Lưu ý: Hạn cam kết sẽ tự động đổi thành ngày cuối cùng của tháng
          </div>
          <form-checkbox :chk-label="$t('isBrandName')" :model="formModel" attribute="isBrandName"
                         :errors="formErrors"/>
          <form-input v-if="formModel.isBrandName" :label="$t('brandName')" :model="formModel" attribute="brandName"
                      :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.isBrandName" :label="$t('brandNameSetupFee')"
                      :model="formModel" attribute="brandNameSetupFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.isBrandName" :label="$t('brandNameHotlineSetupFee')"
                      :model="formModel" attribute="brandNameHotlineSetupFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.isBrandName" :disabled="!formModel.brandNameMainNumber"
                      :label="$t('brandNameMonthlyFee')" :model="formModel" attribute="brandNameMonthlyFee"
                      :errors="formErrors"></form-input>
          <form-checkbox v-if="formModel.isBrandName" :chk-label="$t('brandNameMainNumber')" :model="formModel"
                         attribute="brandNameMainNumber" :errors="formErrors"/>
          <div v-if="formModel.isBrandName" class="alert alert-warning">
            Lưu ý: Chỉ thu phí duy trì định danh/tháng với số hotline chính gắn với định danh
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="cancel" v-if="!reading&&importing">{{ $t('cancel') }}</button>
        <button class="btn btn-primary" @click="reset" v-if="!reading&&!importing&&totalRows>0">Reset</button>
        <button v-if="totalRows===0" class="btn btn-primary" @click="process" :disabled="reading||importing">
          <b-spinner small v-if="reading||importing"></b-spinner>
          {{ $t('import') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>

<script>
import fileReaderStream from 'filereader-stream';
import {saveAs} from 'file-saver'
import Excel from 'exceljs';
import HostSelect from "@/components/HostSelect.vue";
import NetworkSelect from "@/components/NetworkSelect.vue";
import CountrySelect from "@/components/CountrySelect.vue";
import GatewaySelect from "@/components/GatewaySelect.vue";

export default {
  components: {GatewaySelect, CountrySelect, NetworkSelect, HostSelect},
  data() {
    return {
      show: false,
      file: null,
      reading: false,
      importing: false,
      totalRows: 0,
      successCount: 0,
      errorCount: 0,
      importErrors: [],
      cancelRequest: false,
      formModel: {
        country: null,
        host: null,
        backupHost: null,
        gateway: null,
        differenceInOutNumbers: false,
        inbound: true,
        outbound: true,
        isRental: false,
        privateFee: false,
        priority: 1,
        isFixedRoutingIp: false,
        fixedRoutingIp: null,
        isSpam: false,
        isHidden: false,
        isCommit: false,
        commitFromTime: Date.now(),
        commitToTime: null,
        commitMonthlyFee: null,
        isBrandName: false,
        isInboundCharge: false,
        brandNameMainNumber: false,
        brandName: null,
        brandNameSetupFee: null,
        brandNameMonthlyFee: null,
        brandNameHotlineSetupFee: null,
      },
      formErrors: []
    }
  },
  watch: {
    "formModel.isRental": function (val) {
      if (!val) {
        this.formModel.privateFee = null;
        this.formModel.isInboundCharge = null;
      }
    },
    "formModel.privateFee": function (val) {
      if (!val) {
        this.formModel.setupFee = null;
        this.formModel.monthlyFee = null;
        this.formModel.netCallFee = null;
        this.formModel.offnetCallFee = null;
        this.formModel.minBillSecs = null;
        this.formModel.blockBillSecs = null;
      }
    },
    "formModel.isInboundCharge": function (val) {
      if (!val) {
        this.formModel.inboundCallFee = null;
        this.formModel.inboundMinBillSecs = null;
        this.formModel.inboundBlockBillSecs = null;
      }
    },
    "formModel.isBrandName": function (val) {
      if (!val) {
        this.formModel.brandName = null;
        this.formModel.brandNameSetupFee = null;
        this.formModel.brandNameHotlineSetupFee = null;
        this.formModel.brandNameMainNumber = null;
      }
    },
    "formModel.brandNameMainNumber": function (val) {
      if (!val) {
        this.formModel.brandNameMonthlyFee = null;
      }
    },
    "formModel.isCommit": function (val) {
      if (!val) {
        this.formModel.commitMonthlyFee = null;
        this.formModel.commitToTime = null;
      }
    },
  },
  methods: {
    close(evt) {
      if (this.reading || this.importing) {
        evt.preventDefault();
      } else {
        this.reset();
      }
    },
    reset() {
      this.totalRows = 0;
      this.successCount = 0;
      this.errorCount = 0;
      this.importErrors = [];
      this.cancelRequest = false;
      this.reading = false;
      this.importing = false;
      this.file = null;
      this.formModel = {
        country: null,
        host: null,
        backupHost: null,
        gateway: null,
        differenceInOutNumbers: false,
        inbound: true,
        outbound: true,
        isRental: false,
        privateFee: false,
        priority: 1,
        isFixedRoutingIp: false,
        fixedRoutingIp: null,
        isSpam: false,
        isHidden: false,
        isCommit: false,
        commitFromTime: Date.now(),
        commitToTime: null,
        commitMonthlyFee: null,
        isBrandName: false,
        isInboundCharge: false,
        brandNameMainNumber: false,
        brandName: null,
        brandNameSetupFee: null,
        brandNameMonthlyFee: null,
        brandNameHotlineSetupFee: null,
      }
    },
    process(evt) {
      evt.preventDefault();
      if (!this.file) {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('importFileRequired'),
          icon: 'error',
        });
        return;
      }
      if (this.file.name.endsWith('.xls') || this.file.name.endsWith('.xlsx')) {
        this.reading = true;
        let readStream = fileReaderStream(this.file);
        const workbook = new Excel.Workbook();

        workbook.xlsx.read(readStream).then(async () => {
          if (workbook.worksheets.length === 0) {
            throw new Error(this.$t('invalidFileTemplate'));
          }
          let sheet = workbook.worksheets[0];
          if (sheet.actualRowCount < 3) {
            throw new Error(this.$t('fileHasNoData'));
          }
          if (!sheet.getRow(1).values.find(v => v && v.trim() === 'number')) {
            throw new Error(this.$t('invalidFileTemplate'));
          }

          let headerRow = sheet.getRow(1);
          let i = 3;
          this.totalRows = sheet.actualRowCount - 2;
          this.reading = false;
          this.importing = true;
          let checkCount = false
          while (i <= sheet.actualRowCount) {
            if (this.cancelRequest) {
              break;
            }
            let item = this.getItem(headerRow, sheet.getRow(i));
            try {
              if (!checkCount) {
                let checkingItem = {...item, isValidate: true}
                await this.$bgService.post('/phone-number', checkingItem);
              }
              checkCount = true
            } catch (err) {
              this.formErrors = err.response.data;
              break
            }
            try {
              await this.$bgService.post('/phone-number', item);
              this.successCount++;
            } catch (err) {
              this.importErrors.push({row: i, err: err, number: item.number});
              this.errorCount++;
            }
            i++;
          }
        }).catch(err => {
          this.$swal({
            title: this.$t('error'),
            text: err.message,
            icon: 'error',
          });
        }).finally(async () => {
          this.reading = false;
          this.importing = false;
          this.cancelRequest = false;
          this.$bus.$emit('phoneNumber');
        });
      } else {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('invalidFileType'),
          icon: 'error',
        });
      }
    },
    cancel() {
      this.cancelRequest = true;
    },
    downloadErrors() {
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('Import errors');
      sheet.columns = [
        {header: this.$t('rowNumber'), key: 'row', width: 15},
        {header: this.$t('errors'), key: 'error', width: 50},
        {header: this.$t('phoneNumber'), key: 'number', width: 50},
      ];
      for (let err of this.importErrors) {
        sheet.addRow({
          row: err.row,
          error: (err.err.response && err.err.response.status === 422) ? err.err.response.data.map(i => `${i.param}: ${i.msg}`).join(', ') : err.err.message,
          number: err.number ? err.number : ''
        });
      }
      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        saveAs(
            new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'number-import-error.xlsx'
        )
      });
    },
    downloadTemplate: function () {
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('Callio Contacts');
      this.setupSheet(sheet);

      sheet.addRow({
        number: this.$t("phoneNumber"),
        name: this.$t("name"),
        desc: this.$t("desc"),
      });

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        saveAs(
            new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'number-template.xlsx'
        )
      });
    },
    setupSheet(sheet) {
      sheet.columns = [
        {header: 'number', key: 'number', width: 20},
        {header: 'name', key: 'name', width: 20},
        {header: 'desc', key: 'desc', width: 20},
      ];
    },
    getItem(headerRow, row) {
      let item = {};
      for (let j = 1; j <= headerRow.cellCount; j++) {
        let key = headerRow.getCell(j).value;
        let value;
        if (row.getCell(j).isHyperlink) {
          value = row.getCell(j).value.text;
        } else {
          value = row.getCell(j).value;
        }
        if (row.getCell(j).result) {
          value = row.getCell(j).result
        }
        if (!value) {
          item[key] = value;
          continue;
        } else {
          item[key] = value;
        }
      }
      item = {...item, ...this.formModel}
      return item;
    }
  },
  i18n: {
    messages: {
      vi: {
        import: "Tải lên",
        downloadTemplate: "Tải file mẫu",
        selectFile: "Chọn file",
        fileInputPlaceholder: "Chọn file từ máy tính hoặc kéo thả file vào đây",
        isDemo: 'Số demo',
        isRental: "Số cho thuê",
        availableForRent: "Số chưa được thuê",
        privateFee: "Bảng phí riêng",
        setupFee: 'Phí cài đặt',
        monthlyFee: 'Phí hàng tháng',
        netCallFee: 'Phí gọi nội mạng',
        offnetCallFee: 'Phí gọi ngoại mạng',
        minBillSecs: 'Số giây tính cước tối thiểu',
        blockBillSecs: 'Số giây / block tính cước',
        differenceInOutGateways: 'Gọi ra / gọi vào khác gateway',
        outGateway: 'Gateway gọi ra',
        outGatewayProxy: 'Proxy gateway gọi ra',
        differenceInOutNumbers: 'Gọi ra / gọi vào khác số',
        outPhoneNumber: 'Số gọi ra',
        chooseGateway: 'Chọn gateway',
        noClientEngaged: 'Chưa gắn cho khách hàng nào',
        number: 'Số',
        yes: 'Có',
        no: 'Không',
        priority: 'Thứ tự ưu tiên',
        isFixedRoutingIp: 'Sử dụng IP routing cố định',
        fixedRoutingIp: 'IP routing cố định',
        isSpam: "Số bị chặn spam",
        isHidden: "Ẩn số điện thoại ở danh sách gọi",
        isBrandName: "Sử dụng tên định danh",
        brandName: "Tên dịnh danh",
        isInboundCharge: "Tính phí gọi vào",
        inboundCallFee: "Phí gọi vào",
        inboundMinBillSecs: "Số giây tính cước tối thiểu khi gọi vào",
        inboundBlockBillSecs: "Số giây / block tính cước khi gọi vào",
        fixedCallFee: "Thu phí cố định/ cuộc gọi",
        brandNameSetupFee: "Phí đăng ký tên định danh",
        brandNameHotlineSetupFee: "Phí gán tên định danh vào hotline",
        brandNameMonthlyFee: "Phí duy trì tên định danh/Tháng",
        brandNameMainNumber: "Số hotline chính gắn với định danh",
        isCommit: "Số cam kết",
        commitToTime: "Cam kết đến",
        commitFromTime: "Cam kết từ",
        commitMonthlyFee: "Cước gọi tối thiểu / tháng",
        importReadingNotice: "Đang đọc file. Quá trình này có thể sẽ tốn nhiều thời gian nếu file tải lên có dung lượng lớn. Xin đừng tắt cửa sổ trình duyệt cho đến khi quá trình tải lên hoàn tất!",
        invalidFileTemplate: "File tải lên chưa đúng mẫu!",
        importingNotice: "Đang tải dữ liệu lên... Xin hãy kiên nhẫn, việc tải lên sẽ mất một chút thời gian nếu file của bạn quá lớn",
        fileHasNoData: "File không có dữ liệu. Xin hãy kiểm tra lại!",
        importFileRequired: "Bạn cần chọn file tải lên!"
      },
      en: {
        import: "Tải lên",
        downloadTemplate: "Tải file mẫu",
        selectFile: "Chọn file",
        fileInputPlaceholder: "Chọn file từ máy tính hoặc kéo thả file vào đây",
        isDemo: 'Số demo',
        isRental: "Số cho thuê",
        availableForRent: "Số chưa được thuê",
        privateFee: "Bảng phí riêng",
        setupFee: 'Phí cài đặt',
        monthlyFee: 'Phí hàng tháng',
        netCallFee: 'Phí gọi nội mạng',
        offnetCallFee: 'Phí gọi ngoại mạng',
        minBillSecs: 'Số giây tính cước tối thiểu',
        blockBillSecs: 'Số giây / block tính cước',
        differenceInOutGateways: 'Gọi ra / gọi vào khác gateway',
        outGateway: 'Gateway gọi ra',
        outGatewayProxy: 'Proxy gateway gọi ra',
        differenceInOutNumbers: 'Gọi ra / gọi vào khác số',
        outPhoneNumber: 'Số gọi ra',
        chooseGateway: 'Chọn gateway',
        noClientEngaged: 'Chưa gắn cho khách hàng nào',
        number: 'Số',
        yes: 'Có',
        no: 'Không',
        priority: 'Thứ tự ưu tiên',
        isFixedRoutingIp: 'Sử dụng IP routing cố định',
        fixedRoutingIp: 'IP routing cố định',
        isSpam: "Số bị chặn spam",
        isHidden: "Hide phone number in call list",
        isBrandName: "Sử dụng tên định danh",
        brandName: "Tên dịnh danh",
        isInboundCharge: "Tính phí gọi vào",
        inboundCallFee: "Phí gọi vào",
        inboundMinBillSecs: "Số giây tính cước tối thiểu khi gọi vào",
        inboundBlockBillSecs: "Số giây / block tính cước khi gọi vào",
        fixedCallFee: "Thu phí cố định/ cuộc gọi",
        brandNameSetupFee: "Phí đăng ký tên định danh",
        brandNameHotlineSetupFee: "Phí gán tên định danh vào hotline",
        brandNameMonthlyFee: "Phí duy trì tên định danh/Tháng",
        brandNameMainNumber: "Số hotline chính gắn với định danh",
        isCommit: "Số cam kết",
        commitToTime: "Cam kết đến",
        commitFromTime: "Cam kết từ",
        commitMonthlyFee: "Cước gọi tối thiểu / tháng",
        importReadingNotice: "Đang đọc file. Quá trình này có thể sẽ tốn nhiều thời gian nếu file tải lên có dung lượng lớn. Xin đừng tắt cửa sổ trình duyệt cho đến khi quá trình tải lên hoàn tất!",
        invalidFileTemplate: "File tải lên chưa đúng mẫu!",
        importingNotice: "Đang tải dữ liệu lên... Xin hãy kiên nhẫn, việc tải lên sẽ mất một chút thời gian nếu file của bạn quá lớn",
        fileHasNoData: "File không có dữ liệu. Xin hãy kiểm tra lại!",
        importFileRequired: "File is required!"
      }
    }
  }
}
</script>
